import { UPDATE_FORM, RESET_FORM } from "../actions/ProgramForm.action";

const initialState = {
  start_date: "",
  end_date: "",
  client_id:"",
  program_ids: [],
  state_ids: [],
  city_ids: [],
};

const ProgramformReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_FORM:
      return { ...state, ...action.payload };

    case RESET_FORM:
      return { ...initialState };

    default:
      return state;
  }
};

export default ProgramformReducer;
